import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/homes/Index.vue'
const includPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  		return includPush.call(this, location).catch(err => err)
	}
Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',//主页
    component: Home
},
{
    path: "/project",
    name: "Project",//产品
    component: () =>
        import("../views/project/Index.vue"),
},
{
    path: "/media",//媒体
    name: "Media",
    component: () =>
        import("../views/media/Index.vue"),
},

{
    path: "/introduction",//简介
    name: "introduction",
    component: () =>
        import("../views/introduction/Index.vue"),
},
{
    path: "/leaving",//联系
    name: "Leaving",
    component: () =>
        import("../views/Leaving/Index.vue")
},
{
    path: "/company",//加入我们
    name: "Company",
    component: () =>
        import("../views/Company/Index.vue")
},
{
    path: "/unionparty",//加入我们
    name: "unionparty",
    component: () =>
        import("../views/Union/UnionParty.vue")
},
{
    path: "/detail/:id",
    name: "Detail",
    component: () =>
        import("../views/Detail/Index.vue")
}
]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: 'hash',
    // base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    next()
    window.scrollTo(0, 0)
})
export default router